/* eslint-disable react/no-unstable-nested-components */
import React from 'react';
import { Box } from '@chakra-ui/react';
import { DataGrid } from '../../components/datagrid';
import { SearchFilter } from '../../components/inputs/filters/search';
import { PageTitle } from '../../components/PageTitle';
import { useFetch } from '../../hooks/useFetch';
import { getCellStatus } from '../../utils/FormatFunctions';

export function TopicsPage() {
  const baseApiUrl = '/v1/admin';
  const baseUrl = `${baseApiUrl}/rating/topics`;
  const { requestApi, data, loading, error } = useFetch(baseUrl);

  const columns = [
    { name: 'id', label: 'Id' },
    { name: 'name', label: 'Título' },
    { name: 'position', label: 'Posição' },
    { name: 'status', label: 'Status' },
  ];

  return (
    <Box>
      <PageTitle>Tópicos</PageTitle>

      <DataGrid
        columns={columns}
        rows={data?.data}
        requestApi={requestApi}
        error={error}
        baseUrl={baseUrl}
        data={data}
        hasCreate
        loading={loading}
        rowActions={{ show: false, edit: true, delete: true }}
        headerFilters={[
          {
            name: 'search',
            filterComponent: SearchFilter,
          },
        ]}
        formatColum={[
          {
            field: 'status',
            formatField: getCellStatus,
          },
        ]}
      />
    </Box>
  );
}
